import React, { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import { initLenis } from "@/lib/scroll";
import Preloader from "@/components/Preloader";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Achievements from "@/components/Achievements";
import Training from "@/components/Training";
import Coaching from "@/components/Coaching";
import Audience from "@/components/Audience";
import ClassModes from "@/components/ClassModes";
import Process from "@/components/Process";
import Philosophy from "@/components/Philosophy";
import Social from "@/components/Social";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingCta from "@/components/FloatingCta";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-[#050505] text-white">
                    Something went wrong. Please refresh the page.
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        initLenis();
        const t = setTimeout(() => setLoading(false), 1750);
        return () => clearTimeout(t);
    }, []);

    return (
        <ErrorBoundary>
            <div className="grain relative min-h-screen bg-[#050505] text-white">
                <AnimatePresence>{loading && <Preloader />}</AnimatePresence>
                <Navbar />
                <main>
                    <Hero />
                    <Marquee />
                    <About />
                    <Achievements />
                    <Training />
                    <Coaching />
                    <Audience />
                    <ClassModes />
                    <Process />
                    <Philosophy />
                    <Social />
                    <Contact />
                </main>
                <Footer />
                <FloatingCta />
                <Toaster theme="dark" position="bottom-center" />
            </div>
        </ErrorBoundary>
    );
}

export default App;
